export const setFlow = ( state, flow ) => {
    state.flow = flow
    sessionStorage.setItem('profile-flow', flow)
}
